export default __webpack_public_path__ + "static/media/Hair_11_M_C1.f1079832.svg";